export default "__VITE_ASSET__BowzjI6J__"